export const SITE_SELECTION = 'SITE_SELECTION';
export const STAR_SITE_FLAG = '__starSites';
export const SEARCH_INVESTIGATOR = 'SEARCH_INVESTIGATOR';
export const REFRESH_SITE_LIST = 'REFRESH_SITE_LIST';
export const SET_MASTER_FILTERS = 'SET_MASTER_FILTERS';
export const INIT_MASTER_PAGINATION = 'INIT_MASTER_PAGINATION';
